/* unplugin-vue-components disabled */import { render } from "./InternalMessageView.vue?vue&type=template&id=0dac1d16&scoped=true"
import script from "./InternalMessageView.vue?vue&type=script&lang=js"
export * from "./InternalMessageView.vue?vue&type=script&lang=js"

import "./InternalMessageView.vue?vue&type=style&index=0&id=0dac1d16&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dac1d16"]])

export default __exports__